@if (label()) {
  <button
    [type]="type()"
    [nxButton]="nxButtonType()"
    [disabled]="disabled()"
    [class.icon-button]="!label()"
    [attr.data-testid]="testId()"
  >
    @if (iconDefinition()) {
      <nx-icon
        class="nx-margin-right-2xs"
        aria-hidden="true"
        [name]="iconDefinition().name"
        [size]="iconDefinition().size"
      ></nx-icon>
    }
    <span>{{ label() }}</span>
  </button>
} @else if (iconDefinition()) {
  <button
    class="icon-button"
    [nxIconButton]="nxButtonType()"
    [disabled]="disabled()"
    [attr.data-testid]="testId()"
  >
    <nx-icon
      aria-hidden="true"
      [name]="iconDefinition().name"
      [size]="iconDefinition().size"
    ></nx-icon>
  </button>
}
